import React from 'react';
import classnames from 'classnames';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';
import bindOwnClassnamesWithSkin from '@wix/da-shared-react/pkg/utils/bindOwnClassnamesWithSkin';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';

import s from './ConfigPopover.scss';

export interface Props {
  width?: number;
  withPaddings?: boolean;
  className?: string;
  skin?: { [k: string]: string };
  onClose(): void;
  usePortal?: boolean;
  shouldCloseOnClickOutside?: boolean;
  children?: React.ReactNode;
}

const ConfigPopover: React.FC<Props> = ({
  width,
  usePortal = false,
  withPaddings = true,
  shouldCloseOnClickOutside = true,
  skin = {},
  className,
  onClose,
  children,
}) => {
  const styles = bindOwnClassnamesWithSkin(s, skin);

  return (
    <ThemeOverride
      className={classnames('no-theme-skin', styles('theme-wrapper'))}
      theme={ThemeOptions.LIGHT}
    >
      <PositionOnlyPopperPopover
        popoverContent={children}
        width={width}
        onClickOutside={shouldCloseOnClickOutside ? onClose : undefined}
        className={s['ref-style']}
        wrapperClassName={classnames(
          'no-theme-skin',
          styles('tooltip-wrapper'),
          className
        )}
        contentClassName={classnames(
          styles('tooltip-content'),
          withPaddings && styles('with-paddings')
        )}
        placement="bottom"
        secondaryPlacement="end"
        usePortal={usePortal}
      />
    </ThemeOverride>
  );
};
ConfigPopover.displayName = 'ConfigPopover';

export default ConfigPopover;
